import { motion } from 'framer-motion';

export default function Checkbox({
  id,
  label,
  value,
  onChange,
  required = false,
  error = ''
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="w-full"
    >
      <label
        htmlFor={id}
        className="flex items-start gap-3 cursor-pointer group"
      >
        <div className="flex items-center h-6">
          <input
            type="checkbox"
            id={id}
            checked={value || false}
            onChange={(e) => onChange(e.target.checked)}
            required={required}
            className="w-5 h-5 text-renuvia-gold border-2 border-gray-300 rounded focus:ring-2 focus:ring-renuvia-gold transition-all cursor-pointer"
          />
        </div>
        <div className="flex-1">
          <span className="text-sm text-charcoal leading-relaxed">
            {label}
            {required && <span className="text-red-500 ml-1">*</span>}
          </span>
        </div>
      </label>
      {error && (
        <motion.p
          initial={{ opacity: 0, y: -5 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-red-500 text-sm mt-1 ml-8"
        >
          {error}
        </motion.p>
      )}
    </motion.div>
  );
}
